var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8124 1.54883L10.2698 0L5.90618 4.38139L1.54255 0L0 1.54883L5.90618 7.47904L11.8124 1.54883Z","fill":"#333333"}));
}

ArrowDownInline.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
